<nz-layout class="content-default-size">
  <nz-header class="bg-white border-bottom">
    <nz-space>
      <p
        *nzSpaceItem
        class="text-black-50"
        i18n="@@control-service.header.name"
      >
        Control service
      </p>
      <button
        *nzSpaceItem
        nz-button
        nzType="default"
        (click)="showNewComponentModal()"
        i18n="@@control-service.page.control.button.addComponent"
      >
        Add component
      </button>
    </nz-space>
  </nz-header>
  <nz-content class="h-100 bg-white">
    <div nz-row class="h-100">
      <div nz-col nzSpan="24">
        <nz-table
          #groupsTable
          [nzData]="groups()"
          [nzScroll]="tableScroll"
          [nzPageSize]="10"
          nzTableLayout="fixed"
        >
          <thead>
            <tr>
              <th nzShowExpand nzWidth="40px"></th>
              <th
                nzWidth="20%"
                [nzFilters]="orgFilters()"
                [nzFilterFn]="filterOrg"
                [nzSortFn]="compareOrg"
                nzSortOrder="ascend"
              >
                {{ orgColumnName }}
              </th>
              @for (column of listOfColumns; track column.name) {
              <th>{{ column.name }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (group of groupsTable.data; track group.org) {
            <tr>
              <td
                nzShowExpand
                [nzExpand]="isExpanded(group.org)"
                (nzExpandChange)="onExpandChange(group.org, $event)"
              ></td>
              <td colspan="3">
                {{ group.org }} ({{ group.children.length }})
              </td>
            </tr>
            @if (isExpanded(group.org)) {
            @for (data of group.children; track data.id) {
            <tr
              [routerLink]="[
                '/control-service/component',
                data.id,
                data.componentType
              ]"
            >
              <td></td>
              <td></td>
              <td>{{ data.project }}</td>
              <td>{{ data.componentType }}</td>
            </tr>
            }
            }
            }
          </tbody>
        </nz-table>
      </div>
    </div>
    <app-component-modal
      [componentNewModalIsVisible]="showComponentModal"
      (componentNewModalIsVisibleChange)="
        componentNewModalIsVisibleChange($event)
      "
    ></app-component-modal>
  </nz-content>
</nz-layout>
